module.exports = __webpack_public_path__ + "files/d256fb4aef7a9a13d453875f4c6c99e6.svg";